import React from "react"
import MainTitle from "../molecules/titles/MainTitle.molecule"
import PrimaryButton from "../molecules/buttons/PrimaryButton.molecule"

/**
 * @param {import("./ContentLayoutHeader.d").ContentLayoutHeaderProps} props
 * @returns {JSX.Element}
 */
const ContentLayoutHeader = ({
  title,
  subtitle,
  subtitleLoading,
  subtitleAccessory,
  buttonProps,
  extraContent,
  goBack,
}) => {
  const renderButton = buttonProps && !buttonProps.hidden && (
    <PrimaryButton {...buttonProps} />
  )
  return (
    <div
      className="layout-header flex justify-content-between mb-4"
      style={{ minHeight: "45px" }}
    >
      <MainTitle
        title={title}
        subtitle={subtitle}
        subtitleLoading={subtitleLoading}
        subtitleAccessory={subtitleAccessory}
        goBack={goBack}
      />
      <div className="flex justify-content-between gap-2">
        {renderButton}
        {extraContent}
      </div>
    </div>
  )
}

export default ContentLayoutHeader
